import { render, staticRenderFns } from "./DeliveryMap.vue?vue&type=template&id=2595d4fc&"
import script from "./DeliveryMap.vue?vue&type=script&lang=js&"
export * from "./DeliveryMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports